// src/pages/Admin/Vendors/VendorPayouts.tsx
import React from 'react';
import { DollarSign, Calendar, CheckCircle, Clock, AlertCircle } from 'lucide-react';

const VendorPayouts: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Payouts</h2>
          <p className="text-sm text-gray-500">Payment history and earnings</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Total Earnings</p>
          <p className="text-2xl font-bold text-gray-900">$12,450.00</p>
          <p className="text-xs text-green-600">↑ 12% from last month</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Pending Payouts</p>
          <p className="text-2xl font-bold text-yellow-600">$3,200.00</p>
          <p className="text-xs text-gray-500">2 payouts pending</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-4">
          <p className="text-sm text-gray-500">Total Payouts</p>
          <p className="text-2xl font-bold text-green-600">$9,250.00</p>
          <p className="text-xs text-gray-500">8 completed payouts</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <DollarSign className="h-12 w-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500">Payout history will appear here</p>
        <p className="text-sm text-gray-400 mt-1">This feature is coming soon</p>
      </div>
    </div>
  );
};

export default VendorPayouts;